export { DMS_MODULE } from '../../ciselnik/constants';
export const CRUMB_LABEL_KEY = 'edtDmsPracovnik';
export const NAME = 'Pracovnik';

export enum TAB_NAMES {
	BASICINFO = 'BasicInfo',
	LOGINSETTINGS = 'LoginSettings',
}

export const TABS = {
	[TAB_NAMES.BASICINFO]: { id: TAB_NAMES.BASICINFO, labelKey: 'Zakladni_Informace' },
	[TAB_NAMES.LOGINSETTINGS]: { id: TAB_NAMES.LOGINSETTINGS, labelKey: 'LOGIN_SETTINGS' },
};
